import routes from "./src/routes/client"

export default routes
